type MatterRole = {
  name: string;
};

const ROLE = {
  Member: 'Member',
  Admin: 'Admin',
  Owner: 'Owner'
} as const;

type RoleType = (typeof ROLE)[keyof typeof ROLE];
export type Action = 'create' | 'update' | 'read' | 'delete' | 'leave';
export type Resource =
  | 'team'
  | 'team_member'
  | 'team_invitation';

type RolePermissions = {
  [role in RoleType]: Permission[];
};

export type Permission = {
  resource: Resource;
  actions: Action[] | '*';
};

/**
 * Pure permission check: does `permissions` grant any of `actions` on `resource`?
 */
export function hasPermission(
  permissions: Permission[],
  resource: Resource,
  actions: Action[],
): boolean {
  // No requested actions means nothing to grant, even against a wildcard.
  if (actions.length === 0) return false;
  return permissions.some((permission) => {
    // Match the resource
    if (permission.resource !== resource) return false;
    // Check for wildcard (*) permission which grants all actions
    if (permission.actions === '*') return true;
    // Check if any of the required actions are in the permitted actions
    return actions.some((action) => permission.actions.includes(action));
  });
}

export const availableRoles: MatterRole[] = [
  {
    name: 'Member',
  },
  {
    name: 'Owner',
  },
];

export const permissions: RolePermissions = {
  Owner: [
    {
      resource: 'team',
      actions: '*',
    },
    {
      resource: 'team_member',
      actions: '*',
    },
    {
      resource: 'team_invitation',
      actions: '*',
    },
  ],
  Admin: [
    {
      resource: 'team',
      actions: '*',
    },
    {
      resource: 'team_member',
      actions: '*',
    },
    {
      resource: 'team_invitation',
      actions: '*',
    },
  ],
  Member: [
    {
      resource: 'team',
      actions: ['read', 'leave'],
    },
    {
      resource: 'team_member',
      actions: ['read'],
    },
  ],
};
